import PriceItemTable from '@/applications/sales/components/PriceItemTable/PriceItemTable.vue'
import DataTableV2PaginatedMobile from '@/agilis/mobile/DataTableV2PaginatedMobile/DataTableV2PaginatedMobile.vue'
export default {
  name: 'PriceItemTableMobile',
  mixins: [PriceItemTable],
  components: {
    DataTableV2PaginatedMobile
  }
}
